export const improvementTextEntryTemplate = [
    {
        type: 'Text Entry',
        isSelected: false,
        options: [],
        question: 'What is the number one thing you would improve about your organization?',
        questionLabel: 'Improvement',
    }
]